// @ts-nocheck
import {useCallback, useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import {useAuthStore} from "../../../../store/useAuth.store";
import * as feedStyles from "../../GameFeed/_gameFeedCls";
import FeedCard from "../../GameFeed/components/FeedCard";
import * as styles from "../_providerProfileCls";

const GamePostModal = ({games, startIndex, providerName, onClose}) => {
  const {t} = useTranslation();
  const containerRef = useRef(null);
  const cardRefs = useRef([]);
  const handleShowAuthModal = useAuthStore(state => state.handleShowAuthModal);

  const [activeIndex, setActiveIndex] = useState(startIndex);

  // Lock body scroll while modal is open.
  useEffect(() => {
    const footer = document.querySelector("footer");
    const contentArea = document.querySelector(".ant-layout-content");

    const hideFloatBtn = () => {
      const btn = document.getElementById("float-wallet-btn");
      if (btn) btn.style.display = "none";
    };

    if (footer) footer.style.display = "none";
    hideFloatBtn();
    if (contentArea) {
      contentArea.style.overflow = "hidden";
      contentArea.style.paddingBottom = "0";
    }
    document.body.style.overflow = "hidden";

    const observer = new MutationObserver(() => hideFloatBtn());
    observer.observe(document.body, {childList: true, subtree: true});

    return () => {
      observer.disconnect();
      if (footer) footer.style.display = "";
      const btn = document.getElementById("float-wallet-btn");
      if (btn) btn.style.display = "";
      if (contentArea) {
        contentArea.style.overflow = "";
        contentArea.style.paddingBottom = "";
      }
      document.body.style.overflow = "";
    };
  }, []);

  // Scroll to the selected game on first render.
  useEffect(() => {
    const target = cardRefs.current[startIndex];
    if (target) {
      target.scrollIntoView({behavior: "instant", block: "start"});
    }
  }, [startIndex]);

  // Close on Escape key.
  useEffect(() => {
    const handleKeyDown = e => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  // Intersection Observer — detect which card is active.
  const setCardRef = useCallback(
    index => el => {
      cardRefs.current[index] = el;
    },
    []
  );

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            const idx = Number(entry.target.dataset.feedIndex);
            if (!Number.isNaN(idx)) setActiveIndex(idx);
          }
        }
      },
      {threshold: 0.6, root: containerRef.current}
    );

    for (const ref of cardRefs.current) {
      if (ref) observer.observe(ref);
    }
    return () => observer.disconnect();
  }, [games.length]);

  const handleRequestAuth = () => handleShowAuthModal();

  return (
    <div
      className={styles.postModalOverlayCls}
      style={{zIndex: "var(--z-dropdown)"}}
    >
      {/* Close button */}
      <button
        type="button"
        className={styles.postModalCloseCls}
        onClick={onClose}
        aria-label={t("providerProfileClose")}
        style={{zIndex: 501}}
      >
        ✕
      </button>

      {/* Full‑screen feed using the exact same layout & component as /game-feed */}
      <div
        className={feedStyles.gameFeedPageCls}
        style={{height: "100dvh"}}
      >
        <div className={feedStyles.gameFeedHeaderCls}>
          <h1 className={feedStyles.gameFeedTitleCls}>{providerName}</h1>
        </div>

        <div
          className={feedStyles.gameFeedContainerCls}
          ref={containerRef}
        >
          {games.map((game, index) => (
            <div
              // biome-ignore lint/suspicious/noArrayIndexKey: feed can duplicate provider+game tuples; index disambiguates
              key={`${game.game_provider}-${game.game_id}-${index}`}
              ref={setCardRef(index)}
              data-feed-index={index}
            >
              <FeedCard
                game={game}
                isActive={index === activeIndex}
                onRequestAuth={handleRequestAuth}
              />
            </div>
          ))}

          <div className={feedStyles.feedEndMessageCls}>{t("gameFeedEndOfFeed")}</div>
        </div>
      </div>
    </div>
  );
};

export default GamePostModal;
